import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import {
  GET_ALL_ROLES,
  CREATE_ROLE_NAME,
  DELETE_ROLE,
  EDIT_ROLE,
  ASSIGN_ROLE_NAME,
} from "./actionTypes"
import { apiError } from "../actions"
import { changePreloader } from "../../store/layout/actions"
import {
  getAllRolesCall,
  createRoleCall,
  deleteRoleCall,
  editRoleCall,
  assignRoleCall,
} from "../../helpers/repository"
import { getAllRolesResponseSuccess, getAllRoles } from "./actions"
import { showMessage } from "components/Common/Toaster"
import { showErrorMessages } from "helpers/helpers"
import { getAllPermissions } from "store/permissions/actions"

function* attempGetAllRoles() {
  try {
    yield put(changePreloader(true))
    const response = yield call(getAllRolesCall)
    yield put(getAllRolesResponseSuccess(response.data.data))
    yield put(changePreloader(false))
  } catch (error) {
    showErrorMessages(error)
  }
}
function* attempCreateRole(action) {
  const { toggle } = action
  try {
    const response = yield call(createRoleCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllRoles())
    yield put(getAllPermissions())
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}
// -------------------------------------------------------DELETE ROLE------------------------------------------------------
function* attempDeleteRole(action) {
  try {
    const response = yield call(deleteRoleCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllRoles())
    yield put(getAllPermissions())
  } catch (error) {
    showErrorMessages(error)
  }
}

// -------------------------------------------------------EDIT ROLE------------------------------------------------------
function* attempEditRole(action) {
  const { toggle } = action
  try {
    const response = yield call(editRoleCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllRoles())
    yield put(getAllPermissions())
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------ASSIGN ROLE------------------------------------------------------
function* attemptAssignRole(action) {
  const { toggle } = action
  try {
    const response = yield call(assignRoleCall, action.payload, action.roleId)
    showMessage("success", response.data.message)
    yield put(getAllRoles())
    toggle()
  } catch (error) {
    showErrorMessages(error)
  }
}

function* rolesSaga() {
  yield takeEvery(GET_ALL_ROLES, attempGetAllRoles)
  yield takeEvery(CREATE_ROLE_NAME, attempCreateRole)
  yield takeEvery(DELETE_ROLE, attempDeleteRole)
  yield takeEvery(EDIT_ROLE, attempEditRole)
  yield takeEvery(ASSIGN_ROLE_NAME, attemptAssignRole)
}

export default rolesSaga
